import { render, staticRenderFns } from "./DemographicDetailsIcon.vue?vue&type=template&id=d2748a82&"
import script from "./DemographicDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./DemographicDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports